import React from "react";
import ReactDOM from "react-dom/client";
import ConfigProvider from "antd/es/config-provider";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "var(--PRIMARY)",
            colorBgLayout: "var(--BACKGROUND-PRIMARY)",
          },
          components: {
            Select: {
              optionSelectedBg: "var(--BACKGROUND-ACCENT)",
            },
            Button: {
              colorPrimary: "var(--PRIMARY)",
              colorPrimaryHover: "var(--PRIMARY-BTN-HOVER)",
              colorPrimaryActive: "var(--PRIMARY)",

              colorBgContainerDisabled: "var(--BTN-DISABLED)",
              colorTextDisabled: "var(--TEXT-COLOR-WHITE)",
            },
            Menu: {
              itemHoverBg: "var(--ROW-HOVER)",
            },
            Cascader: {
              optionSelectedBg: "var(--ROW-HOVER) !important",
            },
            Table: {
              rowSelectedHoverBg: "var(--ROW-HOVER)",
              rowHoverBg: "var(--ROW-HOVER) !important",
            },
          },
        }}
      >
        <App />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
